import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting-shortcuts.types';

export const meetingFilesSelectors = {
  ...generateResourceSelectors<types.IMeetingFolder>((state) => state.resource.meetingShortcuts),
};

export const meetingFilesSelectedSelectors = {
  ...generateResourceSelectors<types.IMeetingFolder>((state) => state.resource.meetingShortcutsSelected),
};
